// Hook listy komentarzy do pozycji oferty.
// GET /sales-crm/clients/:cid/offers/:oid/positions/:pid/comments

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export type SalesCrmCommentAuthorType = 'TRADER' | 'CLIENT';

export interface ISalesCrmOfferPositionComment {
  id: number;
  offerVersionId: number | null;
  offerVersionPositionId: number | null;
  /** Nazwa pozycji oferty - wypełnione tylko gdy komentarz przypięty do pozycji. */
  positionName?: string | null;
  comment: string | null;
  isVisibleForClient: boolean;
  fileName: string | null;
  fileUrl: string | null;
  authorType: SalesCrmCommentAuthorType | null;
  authorUserId: number | null;
  createdAt: string | null;
}

export interface ISalesCrmOfferPositionCommentsResponse {
  items: ISalesCrmOfferPositionComment[];
}

const getSalesCrmOfferPositionComments = (
  clientId: number,
  offerId: string,
  positionId: number,
  versionId?: number | null
): Promise<ISalesCrmOfferPositionCommentsResponse> => {
  const queryParams: Record<string, number> = {};
  if (versionId) queryParams.versionId = versionId;
  return axios.get(
    `/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}/comments`,
    { params: queryParams }
  );
};

export const useGetSalesCrmOfferPositionComments = (
  clientId: number,
  offerId: string,
  positionId: number,
  versionId?: number | null,
  options?: UseQueryOptions<ISalesCrmOfferPositionCommentsResponse, IError>
) =>
  useQuery<ISalesCrmOfferPositionCommentsResponse, IError>(
    ['sales-crm', 'client', clientId, 'offer', offerId, 'position', positionId, 'comments', versionId ?? null],
    () => getSalesCrmOfferPositionComments(clientId, offerId, positionId, versionId),
    {
      ...options,
      enabled:
        options?.enabled !== false &&
        clientId > 0 &&
        String(offerId).trim().length > 0 &&
        positionId > 0
    }
  );
